"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.timers.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _utils = require("../_utils");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Loading = _interopRequireDefault(require("../Loading"));
var _ssr = require("../_utils/ssr");
var _excluded = ["type", "prefixIcon", "suffixIcon", "size", "mSize", "width", "loading", "className", "style", "disabled", "children"],
  _excluded2 = ["htmlType"]; // import Icon, { NameTypes, NameType } from '../Icon';
var Button = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classnames;
  var type = props.type,
    prefixIcon = props.prefixIcon,
    suffixIcon = props.suffixIcon,
    size = props.size,
    mSize = props.mSize,
    width = props.width,
    loading = props.loading,
    className = props.className,
    style = props.style,
    disabled = props.disabled,
    children = props.children,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('btn');
  var _React$useState = _react.default.useState(!!loading),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    innerLoading = _React$useState2[0],
    setLoading = _React$useState2[1];

  /** Start Update Loading */
  var loadingValue;
  if ((0, _typeof2.default)(loading) === 'object' && loading.delay) {
    loadingValue = loading.delay || true;
  } else {
    loadingValue = !!loading;
  }
  var loadingTimer;
  _react.default.useEffect(function () {
    clearTimeout(loadingTimer);
    if (typeof loadingValue === 'number') {
      loadingTimer = (0, _ssr.isBrowser)() ? window.setTimeout(function () {
        setLoading(loadingValue);
      }, loadingValue) : null;
    } else {
      setLoading(loadingValue);
    }
    return function () {
      clearTimeout(loadingTimer);
    };
  }, [loadingValue]);
  /** End Update Loading */

  var classes = (0, _classnames2.default)(prefixCls, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(prefixCls, "--").concat(type), type), (0, _defineProperty2.default)(_classnames, 'is-disabled', disabled), (0, _defineProperty2.default)(_classnames, "".concat(prefixCls, "--icon"), !!prefixIcon || !!suffixIcon), (0, _defineProperty2.default)(_classnames, "size-".concat(size), size && size !== 'default'), (0, _defineProperty2.default)(_classnames, "m-size-".concat(mSize), mSize && mSize !== 'default'), (0, _defineProperty2.default)(_classnames, "size-".concat(width, "-width"), width), (0, _defineProperty2.default)(_classnames, 'is-loading', innerLoading), (0, _defineProperty2.default)(_classnames, "".concat(className), className), _classnames));
  var handleClick = function handleClick(e) {
    var onClick = rest.onClick;
    if (innerLoading) {
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };
  var renderIcon = function renderIcon(icon) {
    if (!icon) {
      return null;
    }
    if (typeof icon !== 'string') {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(prefixCls, "__icon")
      }, icon);
    }

    // const _icon = icon as NameType;

    // if (typeof icon === 'string' && NameTypes.includes(_icon)) {
    //   return (
    //       <span className={`${prefixCls}__icon`}>
    //         <Icon name={_icon} />
    //       </span>
    //   );
    // }

    return null;
  };
  var kid = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderIcon(prefixIcon), children && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__text")
  }, children), renderIcon(suffixIcon));
  var linkButtonRestProps = (0, _utils.omit)(rest, ['htmlType']);
  if (rest.href) {
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, linkButtonRestProps, {
      className: classes,
      onClick: handleClick
    }), loading ? /*#__PURE__*/_react.default.createElement(_Loading.default, null) : kid);
  }
  var _ref = rest,
    htmlType = _ref.htmlType,
    oProps = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    ref: ref
  }, (0, _utils.omit)(oProps, ['loading']), {
    type: htmlType,
    className: classes,
    style: style,
    onClick: handleClick
  }), loading ? /*#__PURE__*/_react.default.createElement(_Loading.default, {
    size: size === 's' ? size : 'default'
  }) : kid);
});
Button.displayName = 'Button';
Button.defaultProps = {
  type: 'primary',
  size: 'default'
};
var _default = exports.default = Button;